import { useState, useEffect } from 'react';

export const usePersistedState = (key, initialState) => {
    const storageKey = `HAMILTON.${key}`;
    const hydrateState = () => {
        try {
            const persisted = window.localStorage.getItem(storageKey);
            const parsedRes = JSON.parse(persisted);
            
            if (parsedRes.version !== initialState.version) {
                console.warn('State version mismatch, returning initial state...')
                return initialState;
            }
            return parsedRes || initialState;
        } catch {
            console.warn('Failed to read current state version, returning initial state...')
            return initialState;
        }
    };

    const [state, setState] = useState(hydrateState);

    useEffect(() => {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
    }, [state, storageKey]);

    return [state, setState];
}

export const clearAllPersistedState = () => {
    console.log('Clearing State')
    Object.keys(window.localStorage).forEach(key => {
        if (key.startsWith('HAMILTON.')) {
            window.localStorage.removeItem(key);
        }
    });
}
export const clearCache = () => {
    caches
        .keys()
        .then((names) => names.forEach(e => caches.delete(e)));
}